import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

const fetchkeypickupServiceRequestsDone = (state, { payload }) => {
    return {...state, serviceRequests: payload, isKeypickupLoading: false }
}
const fetchkeypickupImportantDocumentsDone = (state, { payload }) => {
    
    const updatedData = payload && payload.length > 0 ? payload.map(entity => ({
        id: entity.id,
        documentType: entity.name,
        ...JSON.parse(entity.data)
    })): [];

    return {...state, importantDocuments: updatedData, isKeypickupLoading: false }
}
const keyPickupLoadingDone = (state) => {
    return {...state, isKeypickupLoading: true };
}

const clearkeyPickupDone = () => {
    return initialState
}

const initialState = {
    serviceRequests: [],
    importantDocuments: [],
    isKeypickupLoading: false
};

export default createReducer(initialState, {
    [TYPES.FETCH_KEY_PICKUP_SERVICE_REQUESTS_DONE]: fetchkeypickupServiceRequestsDone,
    [TYPES.FETCH_KEY_PICKUP_IMPORTANT_DOCUMENTS_DONE]: fetchkeypickupImportantDocumentsDone,
    [TYPES.CLEAR_KEY_PICKUP_DONE]: clearkeyPickupDone,
    [TYPES.KEY_PICKUP_LOADING_DONE]: keyPickupLoadingDone
});
